export const DEFAULT_COLORS = [
	'#A238FF',
	'#C788FF',
	'#3E0269',
	'#DAAFFF',
	'#B560FF',
	'#EDD7FF',

	'#6849FF',
	'#30E0C6',
	'#E64796',
	'#4773EB',
	'#D449D4',
	'#74E788',
	'#FF673D',
	'#B560FF',
	'#FFCE52',
	'#D449D4',
];
